import { Component, OnInit } from '@angular/core';
import { faSearch, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';

import { OccupationService } from 'src/app/shared/services/admin-services/occupation.service';
import { Filter } from 'src/app/shared/models/filter.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Occupation } from 'src/app/shared/models/admin-models/occupation.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-occupations',
  templateUrl: './occupations.component.html',
  styleUrls: ['./occupations.component.sass']
})
export class OccupationsComponent implements OnInit {
  faSearch = faSearch;
  faPencilAlt = faPencilAlt;
  faTrashAlt = faTrashAlt;

  filter: Filter = new Filter({ Top: null, Page: null, Filter: {}, Sort: {} })

  addOrEditBool: Boolean = true;

  occupationArray: Observable<Occupation[]>;
  occupationId: Number;

  filterForm = new FormGroup({
    name: new FormControl('', [])
  })

  occupationForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    hazardLevel: new FormControl('', [Validators.required])
  })

  constructor(private occupationService: OccupationService, private modalService: NgbModal) { }

  ngOnInit() {
    this.getAll();
  }

  getAll() {
    this.filter.data.Filter = {}
    if (this.filterForm.value.name)
      this.filter.data.Filter.Name = this.filterForm.value.name;

    this.occupationArray = this.occupationService.gridView(this.filter)
    // this.occupationService.gridView(this.filter)
    //   .subscribe(
    //     x => {
    //       console.log(x)
    //     }
    //   )
  }

  openAddOccupationModal(modal) {
    this.addOrEditBool = true;
    this.occupationForm.reset();
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
  }
  addOccupation() {
    let occupation = new Occupation({ Name: this.occupationForm.value.name, HazardLevel: this.occupationForm.value.hazardLevel })
    this.occupationService.createOccupation(occupation)
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  openEditModal(modal, id) {
    this.addOrEditBool = false;
    this.occupationService.getOne(id)
      .then(
        (x: { id: Number, name: String, hazardLevel: Number }) => {
          this.occupationId = x.id;
          this.occupationForm.get('name').setValue(x.name)
          this.occupationForm.get('hazardLevel').setValue(x.hazardLevel)
          this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
        }
      )
  }
  editOccupation() {
    let occupation = new Occupation({ ID: this.occupationId, Name: this.occupationForm.value.name, HazardLevel: this.occupationForm.value.hazardLevel })
    this.occupationService.editOccupation(occupation)
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  openDeleteModal(modal, id) {
    this.occupationId = id;
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
  }
  deleteOccupation() {
    this.occupationService.deleteOccupation([this.occupationId])
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  clearFilters() {
    this.filterForm.reset({ name: '' })
    this.getAll();
  }

}
